import { render, staticRenderFns } from "./LmBtnUpdateContent.vue?vue&type=template&id=d81431c2&scoped=true&"
import script from "./LmBtnUpdateContent.vue?vue&type=script&lang=js&"
export * from "./LmBtnUpdateContent.vue?vue&type=script&lang=js&"
import style0 from "./LmBtnUpdateContent.vue?vue&type=style&index=0&id=d81431c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81431c2",
  null
  
)

export default component.exports